import { memo } from "react";
import Lottie from "lottie-react";
import animationData from "../../assets/lottie/gym.json";

type FullScreenLoaderProps = {
  message?: string;
  /** px de ancho/alto de la animación */
  size?: number;
  /** Si true, usa fondo sólido para bloqueos “duros” (inicio de app) */
  solidBackdrop?: boolean;
};

const FullScreenLoader = memo(function FullScreenLoader({
  message = "Cargando…",
  size = 220,
  solidBackdrop = false,
}: FullScreenLoaderProps) {
  return (
    <div
      className={[
        "fixed inset-0 z-[9999] grid place-items-center",
        solidBackdrop ? "bg-background" : "bg-background/70 backdrop-blur-sm",
      ].join(" ")}
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div className="flex flex-col items-center gap-6">
        <div style={{ width: size, height: size }}>
          <Lottie animationData={animationData} loop autoplay />
        </div>
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
});

export default FullScreenLoader;
